import type { PresentationStyle } from 'paintscout'
export function getPrefabStyles(): PresentationStyle[] {
  return [
    {
      presetTitle: 'Uruk',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'montserrat, sans-serif',
      altFontFamily: 'source sans 3, sans-serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        fontFamily: 'alt',
        fontSize: '1rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Ur',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'lato, sans-serif',
      altFontFamily: 'francois one, sans-serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        // Francois One is a heavy condensed display face that already reads large/bold,
        // so it's dropped one step on the body size scale to balance against Lato headings.
        fontFamily: 'alt',
        fontSize: '0.95rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Nippur',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'raleway, sans-serif',
      altFontFamily: 'merriweather, serif',
      heading1: {
        // Raleway's light default weight and small x-height read smaller than other
        // heading fonts at the same size, so headings are bumped one step up the scale.
        fontFamily: 'default',
        fontSize: '2.5rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.5rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1.1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        fontFamily: 'alt',
        fontSize: '1rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Eridu',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'open sans, sans-serif',
      altFontFamily: 'montserrat, sans-serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        fontFamily: 'alt',
        fontSize: '1rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Kish',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'roboto, sans-serif',
      altFontFamily: 'lora, serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        // Lora's moderate x-height reads a touch smaller than Roboto at the same size,
        // so the body size is bumped one step up.
        fontFamily: 'alt',
        fontSize: '1.05rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Larsa',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'source sans 3, sans-serif',
      altFontFamily: 'merriweather, serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        fontFamily: 'alt',
        fontSize: '1rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Hamazi',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'nunito, sans-serif',
      altFontFamily: 'alegreya, serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        // Alegreya is a condensed calligraphic serif with a small x-height, so the body
        // size is bumped one step up to keep it from reading undersized next to Nunito.
        fontFamily: 'alt',
        fontSize: '1.05rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Sippar',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'ubuntu, sans-serif',
      altFontFamily: 'lora, serif',
      heading1: {
        fontFamily: 'default',
        fontSize: '2.25rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.25rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        // Lora reads a touch smaller than Ubuntu at the same size, so it's bumped one step up.
        fontFamily: 'alt',
        fontSize: '1.05rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Adab',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'lora, serif',
      altFontFamily: 'merriweather, serif',
      heading1: {
        // Lora's moderate x-height reads smaller than the sans headings elsewhere in this
        // set, so it's bumped one step up the heading size scale.
        fontFamily: 'default',
        fontSize: '2.5rem',
        fontWeight: 300,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.5rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1.1rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        fontFamily: 'alt',
        fontSize: '1rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    },
    {
      presetTitle: 'Mari',
      accentColor: '#000000',
      backgroundColor: '#FFFFFF',
      buttonColor: '#9e9e9e',
      textColor: '#000000',
      fontFamily: 'josefin sans, sans-serif',
      altFontFamily: 'cardo, serif',
      heading1: {
        // Josefin Sans is a thin geometric face with a very small x-height, so headings are
        // bumped two steps up the scale and heading1's weight is raised from 300 to 400 —
        // at 300 it reads too faint next to the other presets' headings.
        fontFamily: 'default',
        fontSize: '2.75rem',
        fontWeight: 400,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading2: {
        fontFamily: 'default',
        fontSize: '1.75rem',
        fontWeight: 500,
        letterSpacing: '0',
        lineHeight: '1.4',
        textTransform: 'none'
      },
      heading3: {
        fontFamily: 'default',
        fontSize: '1.2rem',
        fontWeight: 500,
        letterSpacing: '1px',
        lineHeight: '1.4',
        textTransform: 'uppercase'
      },
      body: {
        // Cardo is a classic small-x-height book serif that reads noticeably smaller than
        // the sans-serif bodies elsewhere in this set, so it's bumped to the top of the
        // body size scale.
        fontFamily: 'alt',
        fontSize: '1.1rem',
        letterSpacing: '0',
        lineHeight: '1.7',
        textTransform: 'none'
      }
    }
  ]
}
